import CityPagePersianas from "../components/CityPagePersianas";

export default function PersianasCoin() {
  return (
    <CityPagePersianas
      name="Coín"
      slug="coin"
      cp="29100"
      poblacion={21500}
      zonaGeo="Guadalhorce"
      lat={36.6588}
      lng={-4.7563}
      zonas={[
        "Centro Coín",
        "El Charcón",
        "Los Llanos",
      ]}
      landmarks={[
        "Iglesia San Juan",
        "Plaza Alameda",
        "Sierra Alpujata",
      ]}
      municipiosLimitrofes={[
        "Mijas",
        "Alhaurín el Grande",
        "Monda",
        "Tolox",
      ]}
      festivalLocal="Feria de Coín, agosto"
      contextoTipologico="Centro comercial del valle del Guadalhorce, ferreterías y comercios locales con toldos comerciales."
      isCoreZone={false}
    />
  );
}